<template>
  <div class="wia-container">
    <div class="wia-box">
      <h2 class="wia-title">{{config.i18n.wia_title}}</h2>
      <div class="wia-select wia-select--categories">
        <span class="wia-label">{{config.i18n.wia_need_help}} </span><span class="wia-label__strong">{{categorySelected.text}}</span>
        <span class="wia-label__back" v-on:click="backHome()"> {{config.i18n.wia_back}}</span>
      </div>
      <div class="wia-select wia-select--categories" v-if="modelSelected && modelSelected.sku != null">
        <span class="wia-label">{{config.i18n.wia_model_name}} </span>
        <span class="wia-label__strong">{{modelSelected.code}}</span>
      </div>
    </div>
    <div class="wia-box wia-box__light">
      <h2 class="wia-title wia-title__black">{{config.i18n.wia_issue_concern}} </h2>
      <div class="wia-issues wia-issues__full">
        <div class="wia-issue-container wia-issue-container__static">
          <span class="wia-label__selected">{{issueSelected.text}}</span>
          <div class="wia-label__group">
            <span class="wia-label__back" v-on:click="backStep1()"> {{config.i18n.wia_back}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="wia-box wia-box__light">
      <h2 class="wia-title wia-title__black">{{config.i18n.wia_issue_specific}}</h2>
      <div class="wia-issues wia-issues--results">
        <div v-bind:class="{ selected: option.id==subIssueSelected.id }" v-on:click="selectIssue({ id: option.id, text: option.description })" v-for="option in subIssueOptions" class="wia-issue-container" v-bind:value="{ id: option.id, text: option.description }" v-bind:key="option.id">
          <span class="wia-issue">{{option.description}}</span>
        </div>
      </div>
      <div v-show="noSolution" class="wia-issues wia-issues--noresults">
        <a v-bind:href="link" class="wia-title wia-title__black wia-title__underline">{{config.i18n.wia_no_solution}} </a>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
  name: 'WIAStep2',
  title: 'WIA Step2',
  description: 'WIA Step2',
  head: {
    link: [
      {
        rel: 'canonical',
        href: document.location.href + 'step2'
      }
    ]
  },
  canonical () {
    return document.location.href
  },
  meta: {
    name: 'robots',
    content: 'noindex'
  },
  data () {
    return {
      categorySelected: ' ',
      issueSelected: '',
      modelSelected: '',
      subIssueSelected: '',
      subIssueOptions: [
      ],
      link: '',
      error: '',
      noSolution: false
    }
  },
  computed: {
    config: function () {
      return this.$store.state.config
    },
    ...mapState({
      errors: state => state.auth.errors
    }),
    detail: function () {
      return this.$store.state.details
    }
  },
  methods: {
    onSubmit () {
      if (this.subIssueSelected !== '') {
        this.$store.commit('saveSubIssueData', {'subIssue': this.subIssueSelected})
        this.$router.push({
          name: 'WIAStep3',
          params: {
            subIssue: this.subIssueSelected
          },
          query: {
            productLine: this.categorySelected.text,
            product: this.modelSelected.sku,
            macroCat: this.issueSelected.id,
            cat: this.subIssueSelected.id
          }
        })
        if (window.dataLayer) {
          // window.dataLayer.push({
          //   'event': 'WIAPageView',
          //   'eventAction': document.location.href
          // })
        } else {
          console.log(document.location.href)
        }
      }
    },
    selectIssue (issue) {
      this.subIssueSelected = issue
      this.onSubmit()
    },
    backHome () {
      this.$store.commit('resetData')
      this.$router.push({
        name: 'WIA-Home'
      })
    },
    backStep1 () {
      this.$router.push({
        name: 'WIAStep1',
        query: {
          category: this.categorySelected.id,
          product: this.modelSelected.sku,
          macroCat: this.issueSelected.id
        }
      })
    },
    getQueryStringValue (key) {
      // eslint-disable-next-line
      return decodeURIComponent(window.location.href.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"))
    },
    async getCategory (categoryCode) {
      // /product_line/{language}
      await this.$http.get(this.$store.state.config.endpoint + '/product_line/' + this.$store.state.config.language.toLowerCase()).then(
        result => {
          var category = result.body
          var item = category.findIndex(x => x.description === categoryCode)
          if (item !== -1) {
            this.categorySelected = {'id': category[item].id, 'text': categoryCode}
            this.$store.commit('saveDeviceData', {'category': this.categorySelected})
            return 1
          }
          return -1
        })
    },
    getProduct (productCode) {
      // /models/{q}
      this.$http.get(this.$store.state.config.endpoint + '/models/' + productCode).then(
        result => {
          var products = result.body
          var item = products.findIndex(x => x.model === productCode)
          if (item !== -1) {
            this.modelSelected = {'sku': products[item].id, 'code': productCode}
            return 1
          }
          return -1
        }, error => {
          this.errormsg = error.body
        })
    },
    getL1Issue (issueCode) {
      // /macro_categories/{language}
      this.$http.get(this.$store.state.config.endpoint + '/macro_categories/' + this.$store.state.config.language.toLowerCase()).then(
        result => {
          var L1Issues = result.body
          var item = L1Issues.findIndex(x => x.id === issueCode)
          if (item !== -1) {
            this.issueSelected = {'id': issueCode, 'text': L1Issues[item].description}
            return 1
          }
          return -1
        })
    },
    getlink  () {
      const brand = this.$store.state.config.brand
      const contactLinks = this.config.i18n.wia_contact_links

      this.link = contactLinks && contactLinks[brand] ? contactLinks[brand] : ''
    }
  },
  async mounted () {
    window.dataLayer = window.dataLayer || []
    // window.dataLayer.push({
    //   'event': 'problems_solutions_funnel',
    //   'step': 'step2',
    //   'path': document.location.pathname
    // })
    // setTimeout(function () {
    //   const stepName = document.querySelector('.wia-container .wia-box__light:nth-child(3) .wia-title').innerHTML
    //   const urlParams = new URLSearchParams(window.location.search)
    //   const itemCategory = urlParams.get('productLine')
    //   var selectedLabel = document.querySelector('.wia-label__selected');
    //   let troubleShootingIssue = selectedLabel ? selectedLabel.innerHTML : "";

    //   // FUNREQ07
    //   window.dataLayer.push({
    //     'event': "troubleshooting_funnel",
    //     'step_number': "2",
    //     'step_name': "Possible solutions",
    //     'item_category3': itemCategory,
    //     'troubleshooting_issue': troubleShootingIssue
    //   })
    // }, 1500)
    var categoryCode = this.getQueryStringValue('productLine')
    var sku = this.getQueryStringValue('product')
    var L1Issue = this.getQueryStringValue('macroCat')
    // Check for category
    if (this.$store.state.details.category !== null) {
      this.categorySelected = this.$store.state.details.category
    } else {
      if (categoryCode.length > 0) {
        await this.getCategory(categoryCode)
      }
    }

    // Check for sku
    if (this.$store.state.details.model !== null) {
      this.modelSelected = this.$store.state.details.model
    } else {
      if (sku.length > 0) {
        this.getProduct(sku)
      }
    }
    // Check for L1Issue
    if (this.$store.state.details.issue !== null) {
      this.issueSelected = this.$store.state.details.issue
    } else {
      if (L1Issue.length > 0) {
        this.getL1Issue(L1Issue)
      }
    }
    if (categoryCode.length > 0) {
      await this.getCategory(categoryCode)
    }
    if (this.categorySelected !== null) {
      if (this.modelSelected === null || this.modelSelected === undefined || this.modelSelected === '') {
        this.modelSelected = {'sku': null, 'code': null}
      }
      // /categories/{language}/{productLine}/{macroCategory}
      this.$http.get(this.$store.state.config.endpoint + '/categories/' + this.$store.state.config.language.toLowerCase() + '/' + this.categorySelected.id + '/' + L1Issue).then(
        result => {
          this.subIssueOptions = result.body
          if (this.subIssueOptions.length <= 0) {
            this.getlink()
            this.noSolution = true
          }
        }, error => {
          this.getlink()
          this.error = error.body
          this.noSolution = true
        })
      if (this.$store.state.details.subIssue !== null) {
        this.subIssueSelected = this.$store.state.details.subIssue
      }
    } else {
      this.$router.push({
        name: 'WIA-Home'
      })
    }
    if (window.dataLayer) {
      // window.dataLayer.push({
      //   'event': 'WIAPageView',
      //   'eventAction': document.location.href
      // })
    } else {
      console.log(document.location.href)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../style/main.scss';

  .wia-box__light {
    padding-bottom: 0;
    @media (min-width: $desktop) {
      padding-bottom: 35px;
    }
  }

  .wia-title{
    &__underline{
      text-align: center;
      display: block;
      font-size: 26px;
    }
  }

  .brand-theme-id{
    .wia-title{
      &__underline{
        font-family: robotolight !important;
      }
    }
  }

  .brand-theme-hp{
    .wia-title__black{
      text-align: left;
      margin-bottom: 25px;
    }
  }

  .brand-theme-bk{
    .wia-title__black{
      text-align: left;
      margin-bottom: 25px;
    }

    .brand-theme-mb {
      .wia-title__black {
        text-align: left;
        margin-bottom: 25px;
      }
    }
  }

</style>
